<template>
  <v-bottom-nav
    v-if="isMobile"
    :value="true"
    fixed
    color="primary">
    <v-btn
      v-if="showSchedulerButton"
      value="schedule"
      @click="goToScheduler">
      <span class="white--text">Scheduler</span>
      <v-icon class="white--text">mdi-calendar</v-icon>
    </v-btn>
    <v-btn
      @click="goToHome"
      v-if="showSLButton"
      value="home">
      <span class="white--text">Service Logs</span>
      <v-icon class="white--text">mdi-pencil</v-icon>
    </v-btn>
    <v-btn
      v-if="showSLButton"
      @click="goToSearch"
      value="search">
      <span class="white--text">Search Logs</span>
      <v-icon class="white--text">search</v-icon>
    </v-btn>
  </v-bottom-nav>
</template>

<script>
/* eslint-disable indent */
  import JWTHelper from '@/jwt-token';
  import router from '@/router';

  export default {
    name: 'BottomNav',
    computed: {
      isMobile() {
        return this.$mq === 'mobile';
      },
      showSLButton() {
        return JWTHelper.hasServiceLogRights();
      },
      showSchedulerButton() {
        return JWTHelper.hasSchedulerRights();
      }
    },
    methods: {
      goToHome() {
        router.push('/dashboard');
      },
      goToScheduler() {
        router.push('/scheduler');
      },
      goToSearch() {
        router.push('/search');
      }
    }
  };
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/bottom-nav.vue